module.exports = __webpack_public_path__ + "img/youtube.8eeda1ae.svg";